import { useState, useEffect } from 'react';
import { servGetRegisteredCompanies } from '../../services/ide-apis';
import { message, Select } from 'antd';
import { global_var } from '../../services/cs-lab-config';

const CompanyLoader = ({ onChange }) => {
  const [companySearchKey, setCompanySearchKey] = useState('');
  const [companyList, setCompanyList] = useState([]);
  const [companySelectedList, setCompanySelectedList] = useState([]);

  let timeout;
  const { Option } = Select;

  const handleSearchChange = (value) => {
    setCompanySearchKey(value);

    if (timeout) {
      clearTimeout(timeout);
    }

    if (value) {
      timeout = setTimeout(() => {
        loadCompanies(value);
      }, 300);
    }
  };

  const loadCompanies = (companyName = '') => {
    const reqObj = {
      companyName: companyName,
      companyId: global_var.company_id,
      getAncestors: true
    }  
    servGetRegisteredCompanies(reqObj)
      .then((response) => {
        response = response.data;
        if (response.statusCode === 200) {
          setCompanyList(response.companies);
        } else {
          message.error(response.message);
        }
      })
      .catch((error) => {
        console.error('Error loading companies:', error);
      });
  };

  useEffect(() => {
    loadCompanies();
  }, []);

  const handleCompanySelectionChanged = (companyId) => {
    const selectedCompany = companyList.find((company) => company._id === companyId); 
    const selectedCompanyIndex = companySelectedList.findIndex((cObj) => cObj.id === companyId);
  
    if (selectedCompanyIndex === -1) {
      if (companySelectedList.length) {
        const updatedList = companySelectedList.map((c) => ({ ...c, selected: false }));
        setCompanySelectedList(updatedList);
      }
      setCompanySelectedList([{ ...selectedCompany, selected: true }]);
      setCompanySearchKey(selectedCompany ? selectedCompany.companyName : '');
    } else {
      const updatedList = [...companySelectedList];
      updatedList.splice(selectedCompanyIndex, 1);
      setCompanySelectedList(updatedList);
      setCompanySearchKey('');
    }
  
    onChange && onChange(companyId);
  };  
  
  

  return (
    <div>
                                                                      
      <Select
        showSearch
        value={
          companySearchKey !== '' ? companySearchKey :
          (companySelectedList.length > 0 ? companySelectedList[0].companyName : undefined)
        }
        placeholder="Search for a company"
        defaultActiveFirstOption={false}
        showArrow={false}
        filterOption={false}
        onSearch={handleSearchChange}
        onChange={(value) => handleCompanySelectionChanged(value)}
        style={{ width: '350px' }}
      >
        {companyList.map((company) => (
          <Option key={company._id} value={company._id}>
            {company.companyName} - ({company.domainName[0]})
          </Option>
        ))}
      </Select>

      {/* {companySelectedList.length > 0 && (
        <div className="col-xs-12 no-padding-h">
          {companySelectedList.map((companyObj) => (
            <span key={companyObj._id} className="badge badgeInfo p-sm m-r m-b fade-in">
              {companyObj.companyName}
            </span>
          ))}
        </div> */}
      {/* )} */}
    </div>
  );
};

export default CompanyLoader;
